let slickActive = Array.from(document.querySelectorAll(".slick-dots"));
slickActive.forEach(item => {
    if (item.childElementCount == 1) {
        item.style.display = "none";
    }
});


